// https://dimsemenov.com/plugins/magnific-popup/
// http://stackoverflow.com/questions/22993267/including-this-data-in-ajax-call-when-opening-magnific-popup
S.magnificXX = {
    init()
    {
        this.$module.magnificPopup({
            type: 'inline',
            preloader: false,
            midClick: true,

            // showCloseBtn: true,
            // closeBtnInside: false,
            // Delay in milliseconds before popup is removed
            removalDelay: 300,

            // Class that is added to popup wrapper and background
            // make it unique to apply your CSS animations just to this exact popup
            mainClass: 'mfp-fade',
            closeMarkup: '<div class="mfp-close-outer"><button title="%title%" class="mfp-close"></button></div>',
        });
    },

    remove()
    {
        this.$module.magnificPopup.close();
    },
};


S.magnificImage = {

    config: {

    },

    elements: {},

    init()
    {
        this.$module.magnificPopup({
            type: 'image',
            closeOnContentClick: true,

            // closeBtnInside: false,
            fixedContentPos: true,

            // mfp-no-margins class to remove default margin from left and right side
            mainClass: 'mfp-with-zoom',
            image: {
                verticalFit: true,
            },
            // zoom: {
            //     enabled: true,
            //
            //     // don't foget to change the duration also in CSS
            //     duration: 300,
            // },
        });
    },

};

S.magnificIframe = {

    config: {

    },

    elements: {},

    init()
    {
        this.$module.magnificPopup({
            type: 'iframe',
            preloader: false,

            // Delay in milliseconds before popup is removed
            removalDelay: 300,

            // Class that is added to popup wrapper and background
            // make it unique to apply your CSS animations just to this exact popup
            mainClass: 'mfp-fade',

            callbacks: {
                open()
                {
                    if ($(window).height() >= $(document).height())
                    {
                        $('html').addClass('magnific-popup-scroller');
                    }
                    else
                    {
                        $('html').addClass('magnific-popup-no-scroller');
                    }
                },
                close()
                {
                    if ($(window).height() >= $(document).height())
                    {
                        $('html').removeClass('magnific-popup-scroller');
                    }
                    else
                    {
                        $('html').removeClass('magnific-popup-no-scroller');
                    }
                },
            },
        });
    },

    removeMfp()
    {
        var $module = this.$module;

        $module.magnificPopup.close();
    },
};
